__turbopack_context__.v({
  "accordion": "PlentyModal-module-scss-module__89ub1q__accordion",
  "comparison": "PlentyModal-module-scss-module__89ub1q__comparison",
  "enforced-modal": "PlentyModal-module-scss-module__89ub1q__enforced-modal",
  "faq-footer": "PlentyModal-module-scss-module__89ub1q__faq-footer",
  "footer": "PlentyModal-module-scss-module__89ub1q__footer",
});
